var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.24 10H13.34C11.15 10 10 11.15 10 13.33V15.23C10 17.41 11.15 18.56 13.33 18.56H15.23C17.41 18.56 18.56 17.41 18.56 15.23V13.33C18.57 11.15 17.42 10 15.24 10Z",
    fill: "#0D062D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M26.6699 10H24.7699C22.5899 10 21.4399 11.15 21.4399 13.33V15.23C21.4399 17.41 22.5899 18.56 24.7699 18.56H26.6699C28.8499 18.56 29.9999 17.41 29.9999 15.23V13.33C29.9999 11.15 28.8499 10 26.6699 10Z",
    fill: "#0D062D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6699 21.4301H24.7699C22.5899 21.4301 21.4399 22.5801 21.4399 24.7601V26.6601C21.4399 28.8401 22.5899 29.9901 24.7699 29.9901H26.6699C28.8499 29.9901 29.9999 28.8401 29.9999 26.6601V24.7601C29.9999 22.5801 28.8499 21.4301 26.6699 21.4301Z",
    fill: "#0D062D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.24 21.4301H13.34C11.15 21.4301 10 22.5801 10 24.7601V26.6601C10 28.8501 11.15 30.0001 13.33 30.0001H15.23C17.41 30.0001 18.56 28.8501 18.56 26.6701V24.7701C18.57 22.5801 17.42 21.4301 15.24 21.4301Z",
    fill: "#0D062D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.7240f75f8fb37bbd552b10005b10e4b3.svg";
export { ForwardRef as ReactComponent };